var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00854492,
    y: 0.623932,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4B00A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1624 14.8465C30.1624 13.7371 29.2547 12.8294 28.1453 12.8294H12.0086C10.8992 12.8294 9.99149 13.7371 9.99149 14.8465V26.9491C9.99149 28.0585 10.8992 28.9662 12.0086 28.9662H28.1453C29.2547 28.9662 30.1624 28.0585 30.1624 26.9491V14.8465ZM28.1453 14.8465L20.077 19.8893L12.0086 14.8465H28.1453ZM28.1453 26.9491H12.0086V16.8636L20.077 21.9063L28.1453 16.8636V26.9491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/Email Icon.c4485f46f278b32e06532cbafd7a14da.svg";
export { ForwardRef as ReactComponent };